import * as React from 'react';
import { getValue, Row } from '../Row';
import { selectActiveRecommendedPackage, selectActiveService } from '../../../../selectors/publishTerms';
import { useSelector } from 'react-redux';
import { Discount } from '../Discount';

export const SubscriptionContainer = () => {
  const activeService = useSelector(selectActiveService);
  const activePackage = useSelector(selectActiveRecommendedPackage);

  if (!activeService || !activePackage) {
    return null;
  }

  const { name } = activeService;
  const { totalMarketingPrice, totalPrice, durationInDays } = activePackage;

  const priceValue = getValue({ price: totalMarketingPrice });

  const discount = totalMarketingPrice - totalPrice;

  const discountFixed = Math.round(discount * 100) / 100;

  return (
    <>
      <Row name={name} value={priceValue} />
      {!!discount && <Discount discount={discountFixed} days={durationInDays} />}
    </>
  );
};
